// Global
import React from 'react';
import { Field, Item } from '@sitecore-content-sdk/nextjs';
import { useSitecorePage } from 'lib/hooks/sitecore/useSitecorePage';

// Local
import useDictionary from 'lib/hooks/useDictionary';
import { SvgIcon } from 'components/helpers/SvgIcon';
import styles from './ProductRelatedResources.module.scss';

const YOUTUBE_BASE_URL = 'https://www.youtube.com/watch?v=';

interface VideoItem extends Item {
  fields: {
    videoHeadline?: Field<string>;
    videoId?: Field<string>;
  };
}

interface ProductRelatedResourcesRouteFields {
  relatedResources?: VideoItem[];
}

export function ProductRelatedResources() {
  const route = useSitecorePage();
  const { getDictionaryValue } = useDictionary();
  const headingKey = 'Components.Product.ProductRelatedResources.Heading';

  const routeFields = route?.fields as ProductRelatedResourcesRouteFields;
  const relatedResources = routeFields?.relatedResources;

  if (!relatedResources?.length) {
    return null;
  }

  const resolvedHeading = getDictionaryValue(headingKey);
  const heading =
    !resolvedHeading || resolvedHeading === headingKey ? 'Related Resources' : resolvedHeading;

  return (
    <div className={styles.productRelatedResourcesContainer}>
      <div className={styles.productRelatedResourcesContent}>
        <h2 className={styles.productRelatedResourcesHeading}>{heading}</h2>
      </div>
      <ul className={styles.productRelatedResourcesLinkList}>
        {relatedResources.map((item, index) => {
          const videoHeadline = item.fields?.videoHeadline?.value;
          const videoId = item.fields?.videoId?.value;

          if (!videoId || !videoHeadline) {
            return null;
          }

          const youtubeUrl = `${YOUTUBE_BASE_URL}${videoId}`;

          return (
            <li key={item.id ?? index} className={styles.productRelatedResourcesItem}>
              <a
                href={youtubeUrl}
                target="_blank"
                rel="noopener noreferrer"
                className={styles.productRelatedResourcesLink}
              >
                <span>{videoHeadline}</span>
                <SvgIcon icon="new-tab" size="sm" iconPosition="after" aria-hidden="true" />
              </a>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
